<ion-toolbar>
  <ion-buttons slot="start">
    <ion-back-button defaultHref="/"></ion-back-button>
  </ion-buttons>
  <ion-title>Page not found</ion-title>
</ion-toolbar>
<ion-content class="ion-padding">
  <div class="error-container">
    <div class="icon-badge">
      <ion-icon name="compass-outline"></ion-icon>
    </div>
    <h1>We couldn't find that page</h1>
    <p class="message">
      Sorry about that. The page you're looking for may have been moved,
      renamed, or might never have existed. Let's get you back on track.
    </p>
    <ion-button
      expand="block"
      shape="round"
      class="action"
      [routerLink]="CommonRoute.HOME"
    >
      <ion-icon slot="start" name="home-outline"></ion-icon>
      Back to home
    </ion-button>
  </div>
</ion-content>
